import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { TableRowsLoader } from '../../components/styledComponent/table/TableLoader';
import { endpoints } from '../../api/endpoints';
import { TableHeadCell } from '../../components/styledComponent/table/TableCell';
import { Box, Chip, Grid, Paper, Tooltip, Typography } from '@mui/material';
import { TablePagination } from '../../components/pagination/Pagination';
import { LoadingButton } from '@mui/lab';
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { Refresh, Search, RequestPage } from '@mui/icons-material';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { useCrudForm } from '../../api/useCrudForm';
import moment from 'moment';
import { CustomModal } from '../../components/modal/customModal';
import { toast } from "react-toastify";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import * as XLSX from 'xlsx';
import SingleInputDateRangePicker from '../../components/dateRange/DateRange';
import LockerPenaltyForm from './LockerPenaltyForm';
import AddEditModal from '../../components/modal/Modal';

export default function LockerChargeListTable({ refetchData, loading, setLoading, buttonLoading, setButtonLoading, lockerLocationList, setLockerLocationList, count, setSkip, setTake, take, skip, rows }: { refetchData: any, loading: any, setLoading: any, buttonLoading: any, setButtonLoading: any, lockerLocationList: any, setLockerLocationList: any, take: any, skip: any, setSkip: any, setTake: any, count: any, rows: any }) {

    const initialValues = { isChargeDeducted: null, transationType: 0, isPenalty: '', customerName: '', lockerNo: '', fromDate: '', toDate: '', location: '', penalOption: '', renewOption: '' }
    const [openAlertModal, setOpenAlertModal] = useState(false);
    const [isChargeModal, setIsChargeModal] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [transactionType, setTransactionType] = useState<any>([]);

    const [message, setMessage] = useState<any>(null);

    const { handleSubmit, control, formState: { errors, }, setValue, getValues } = useForm({
        defaultValues: initialValues
    })

    const handleSearchButtonClick = (values: any) => {
        setSkip(0)
        setTake(take)
        setButtonLoading(true)
        refetchData({ isChargeDeducted: values?.isChargeDeducted, isPenalty: values?.isPenalty, lockerNo: values?.lockerNo, fromDate: values?.fromDate, toDate: values?.toDate, customerName: values?.customerName, location: values?.location, penalOption: values?.penalOption, renewOption: values?.renewOption, transationType: values?.transationType ?? 0 })
    };

    const resetSearch = () => {
        setValue("isChargeDeducted", null);
        setValue("isPenalty", '');
        setValue("customerName", '');
        setValue("fromDate", '');
        setValue("toDate", '');
        setValue("lockerNo", '');
        setValue("location", '');
        setValue("penalOption", '');
        setValue("renewOption", '');
        setValue("transationType", 0);
        refetchData({})
    };

    const { get, add } = useCrudForm();

    const getFilterSelectData = () => {
        get({
            endpoints: endpoints.common.getLocations(),
            onSuccess: (data: any) => {
                setLockerLocationList(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    const getTransactionType = () => {
        get({
            endpoints: endpoints.lockerCharge.getTransactionType,
            onSuccess: (data: any) => {
                setTransactionType(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    const onRenew = (lockerId: number, customerId: number) => {
        setButtonLoading(true)
        add({
            endpoints: endpoints.lockerCharge.renew(lockerId, customerId),
            onSuccess: (data: any) => {
                setOpenAlertModal(false)
                toast.success(data.message, { style: { background: '#3150A1' } })
                setButtonLoading(false)
                refetchData({})
            },
            onError: (error: any) => {
                setOpenAlertModal(false)
                setButtonLoading(false)
                toast.error(error?.message ?? error)
            },
            values: {}
        })
    }

    const onClose = () => {
        setOpenAlertModal(false)
        setSelectedItem(null)
        setMessage(null)
    }

    const handleDownload = () => {
        setExportLoading(true)
        get({
            endpoints: endpoints.lockerCharge.list({
                fromDate: getValues()?.fromDate,
                toDate: getValues()?.toDate,
                customerName: getValues()?.customerName,
                lockerNo: getValues()?.lockerNo,
                location: getValues()?.location,
                penalOption: getValues()?.penalOption,
                isPenalty: getValues()?.isPenalty,
                renewOption: getValues()?.renewOption,
                isChargeDeducted: getValues()?.isChargeDeducted,
                transationType: getValues()?.transationType,
                isExport: true,
            }),
            onSuccess: (data: any) => {
                const excelData = data.data?.list && data.data?.list.length > 0 ? data.data?.list.map((cus: any, index: number) => [
                    index + 1,
                    cus.customerName,
                    cus.lockerNo,
                    cus.location,
                    cus.isExpired ? `Expired on: ${moment(cus.expiryDate).format('YYYY/M/D')}` : cus.isChargeDeducted ? `Charged on: ${moment(cus.renewDate).format('YYYY/M/D')}` : `Renewal on: ${moment(cus.renewDate).format('YYYY/M/D')}`,
                    `${cus.discount ?? 0} %`,
                    `${cus.penalty ?? 0}`,
                    `${cus.chargeAmount ?? 0}`,
                    cus.isExpired ? 'Yes' : 'No',
                    cus.isChargeDeducted ? 'Yes' : 'No',
                    cus.remarks
                ]) : []
                const headers = ["S.N", "Customer Name", "Locker", "Location", "Expiry/Renew", "Discount", "Penalty", "Deducted Amt.", "Is Expired?", "Is Deducted?", "Remarks"]
                const workbook = XLSX.utils.book_new();
                const worksheet = XLSX.utils.json_to_sheet(excelData);
                XLSX.utils.book_append_sheet(workbook, worksheet, "Customer Lockers");
                XLSX.utils.sheet_add_aoa(worksheet, [headers]);
                const name = `LockerCharges.xlsx`;
                XLSX.writeFile(workbook, name, { compression: true });
                setExportLoading(false)
            },
            onError: () => setExportLoading(false)
        })
    };

    useEffect(() => {
        setLoading(true)
        getFilterSelectData()
        refetchData({ isChargeDeducted: getValues()?.isChargeDeducted, lockerNo: getValues()?.lockerNo, fromDate: getValues()?.fromDate, toDate: getValues()?.toDate, customerName: getValues()?.customerName, location: getValues()?.location, penalOption: getValues()?.penalOption, renewOption: getValues()?.renewOption, transationType: getValues()?.transationType ?? 0 })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skip, take])

    return (<>
        <Typography sx={{ color: 'gray', fontSize: '13px', marginBottom: '12px' }}>Search Locker Charges</Typography>
        <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'start', marginBottom: "24px" }}>
            <Grid item xs={2}>
                <ControlledInput name="customerName" control={control} errors={errors} label="Customer Name" size={'small'} />
            </Grid>
            <Grid item xs={2}>
                <ControlledInput name="lockerNo" control={control} errors={errors} label="Locker No" size={'small'} />
            </Grid>
            <Grid item xs={2}>
                <CustomSelect height='2.5rem' label="Locker Location" name="location" errors={errors?.location?.message} control={control} values={lockerLocationList ?? []} size={12} setValue={setValue} />
            </Grid>
            <SingleInputDateRangePicker control={control} errors={errors} setValue={setValue} getValues={getValues} />
            <Grid item xs={2}>
                <CustomSelect height='2.5rem' label="Is Deducted" name="isChargeDeducted" errors={errors?.isChargeDeducted?.message} control={control} values={[{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }]} size={12} setValue={setValue} />
            </Grid>
            <Grid item xs={2}>
                <CustomSelect height='2.5rem' label="Penalty?" name="isPenalty" errors={errors?.isPenalty?.message} control={control} values={[{ id: 'true', name: 'Yes' }, { id: 'false', name: 'No' }]} size={12} setValue={setValue} />
            </Grid>
            <Grid item xs={2.5}>
                <CustomSelect height='2.5rem' label="Penal Option" name="penalOption" errors={errors?.penalOption?.message} control={control} values={[
                    { id: 0, name: 'All' },
                    { id: 1, name: 'Locker Wise' },
                    { id: 2, name: 'Penalized' },
                    { id: 3, name: 'Failed' }
                ]} size={12} isEnum={true} setValue={setValue} />
            </Grid>
            <Grid item xs={2.5}>
                <CustomSelect height='2.5rem' label="Renew Option" name="renewOption" errors={errors?.renewOption?.message} control={control} values={[
                    { id: 0, name: 'All' },
                    { id: 1, name: 'Locker Wise' },
                    { id: 2, name: 'Renewed' },
                    { id: 3, name: 'Failed' }
                ]} size={12} isEnum={true} setValue={setValue} />
            </Grid>
            <Grid item xs={2}>
                <CustomSelect isEnum={true} onFocused={getTransactionType} height='2.5rem' label="Transaction Type" name="transationType" errors={errors?.transationType?.message} control={control} values={transactionType} size={12} setValue={setValue} />
            </Grid>
            {/* <Grid item style={{ display: 'flex', justifyContent: 'right', alignContent: 'right' }}> */}
            <Grid item style={{ display: 'flex', justifyContent: 'flex-end', alignContent: 'right' }}>
                <LoadingButton loading={buttonLoading} onClick={() => resetSearch()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1' }, paddingX: '2px' }} >Reset</LoadingButton>
                <LoadingButton type='submit' loading={buttonLoading} onClick={(e) => { e.preventDefault(); handleSubmit(handleSearchButtonClick)() }} variant="contained" sx={{ marginLeft: '16px', backgroundColor: '#3150A1', '&:hover': { backgroundColor: '#3150A1', paddingX: '2px' } }} ><Search /></LoadingButton>
                <LoadingButton loading={exportLoading} onClick={() => handleDownload()} variant="contained" sx={{ padding: '4px 8px', backgroundColor: '#3150A1', marginLeft: '16px', '&:hover': { backgroundColor: '#3150A1', } }}>
                    <CloudDownloadIcon />
                    <Typography style={{ fontSize: '14px', marginLeft: '4px' }}>Export</Typography>
                </LoadingButton>
            </Grid>

        </Grid>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableHeadCell minwidth='40px'>S.N</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'150px'}>Customer Name</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'80px'}>Locker No.</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'90px'}>Locker Location</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'60px'}>Expiry/Renew</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'80px'}>Discount</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'90px'}>Penalty</TableHeadCell>
                            <TableHeadCell align="left" minwidth={'90px'}>Amount</TableHeadCell>
                            <TableHeadCell align="center" minwidth={'60px'}>Is Expired?</TableHeadCell>
                            <TableHeadCell align="center" minwidth={'60px'}>Is Deducted?</TableHeadCell>
                            <TableHeadCell align="center" minwidth={'60px'}>Remarks</TableHeadCell>
                            <TableHeadCell align="center" minwidth={'50px'}>Action</TableHeadCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? <TableRowsLoader rowsNum={6} colNum={12} />
                            : (!rows || rows.length <= 0 ?
                                <TableRow>
                                    <TableCell colSpan={10} align='center'>No Data Found</TableCell>
                                </TableRow>
                                : rows.map((row: any, index: number) => (
                                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}  >
                                        <TableCell style={{ padding: '4px' }} align='center'>{skip > 0 ? skip * take + index + 1 : ++index}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{row.customerName}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{row.lockerNo}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{row.location}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>
                                            {
                                                row.isExpired ? <>
                                                    <Box sx={{ fontSize: '10px' }}>Tran Date:<Typography sx={{ color: 'green', fontSize: '11px' }}>{moment(row.tranDate).format('YYYY/M/D')}</Typography></Box>
                                                    <Box sx={{ fontSize: '10px' }}>Expired on:<Typography sx={{ color: 'red', fontSize: '11px' }}>{moment(row.expiryDate).format('YYYY/M/D')}</Typography></Box>
                                                    {row.isChargeDeducted ? <Box sx={{ fontSize: '10px' }}>Renewal on:<Typography sx={{ color: 'green', fontSize: '11px' }}>{row.renewDate ? moment(row.renewDate).format('YYYY/M/D') : ""}</Typography></Box> : null}
                                                </> : row.isChargeDeducted ? <>
                                                    <Box sx={{ fontSize: '10px' }}>Tran Date:<Typography sx={{ color: 'green', fontSize: '11px' }}>{row.tranDate ? moment(row.tranDate).format('YYYY/M/D') : ""}</Typography></Box>
                                                    <Box sx={{ fontSize: '10px' }}>Charged on:<Typography sx={{ color: 'green', fontSize: '11px' }}>{row.renewDate ? moment(row.renewDate).format('YYYY/M/D') : ""}</Typography></Box>
                                                    <Box sx={{ fontSize: '10px' }}>Expiry Date:<Typography sx={{ color: 'red', fontSize: '11px' }}>{row.expiryDate ? moment(row.expiryDate).format('YYYY/M/D') : ""}</Typography></Box>
                                                </> : null
                                            }
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{`${row.discount ?? 0} %`}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{`${row.penalty ?? 0}`}</TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{`${row.chargeAmount ?? 0}`}</TableCell>
                                        <TableCell align="center" style={{ padding: '4px', fontSize: "12px" }}><Chip color={row.isExpired ? 'error' : 'primary'} label={row.isExpired ? 'Yes' : 'No'} /></TableCell>
                                        <TableCell align="center" style={{ padding: '4px', fontSize: "12px" }}><Chip color={row.isChargeDeducted ? 'success' : 'error'} label={row.isChargeDeducted ? 'Yes' : 'No'} /></TableCell>
                                        <TableCell align="left" style={{ padding: '4px', fontSize: "12px" }}>{row.remarks}</TableCell>
                                        <TableCell align="center" style={{ padding: '4px', fontSize: "12px" }}>
                                            {
                                                row.isExpired && !row.isChargeDeducted ?
                                                    <Tooltip title="Renew" >
                                                        <Refresh sx={{ width: '30px', height: '30px', backgroundColor: '#32CD33', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => {
                                                            setSelectedItem({ lockerId: row.lockerId, customerId: row.customerId })
                                                            setMessage(`Are you sure want to renew ${row.customerName}'s locker ${row.lockerNo}?`)
                                                            setOpenAlertModal(true)
                                                        }} />
                                                    </Tooltip>
                                                    : null
                                            }
                                            {
                                                row.penalty && row.penalty > 0 && !row.isChargeDeducted ?
                                                    <Tooltip title="Penalty Charge" >
                                                        <RequestPage sx={{ width: '30px', height: '30px', backgroundColor: '#3150A1', borderRadius: '100%', padding: '6px', color: 'white' }} onClick={() => {
                                                            setIsChargeModal(true)
                                                            setSelectedItem({ ...row })
                                                        }} />
                                                    </Tooltip>
                                                    : null
                                            }
                                        </TableCell>
                                    </TableRow>
                                )))}
                    </TableBody>
                </Table>
            </TableContainer>
            {rows && (rows?.length > 0 || !loading) ? <TablePagination count={count} skip={skip} setSkip={setSkip} take={take} setTake={setTake} /> : null}
        </Paper>
        <CustomModal openAlertModal={openAlertModal} setOpenAlertModal={setOpenAlertModal} onSuccess={() => onRenew(selectedItem.lockerId, selectedItem.customerId)} onError={() => onClose()} message={message} isLoading={buttonLoading} />
        <AddEditModal title={`Locker (${selectedItem?.lockerNo}) Penalty Detail`} setOpen={setIsChargeModal} setSelectedItem={setSelectedItem} open={isChargeModal}>
            <LockerPenaltyForm selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setIsChargeModal} open={isChargeModal} getMainValues={getValues} setMainValue={setValue} refetchData={refetchData} />
        </AddEditModal>
    </>
    );
}